export default {
  exhibition: {
    expectArrivalDate: '期望到货日期',
    employeeName: '采购员',
    plantNo: '工厂',
    purchaseSeq: '项次-项序',
    purchasePhaseSeq: '项次-项序-分批量',
    goodsNo: '料号',
    goodsName: '品名',
    spec: '规格',
    remarks: '采购备注',
    batchPurQty: '订单量',
    sumDeliveryQty: '发货总量',
    sumReceiveQty: '收货总量',
    deliveryQty: '发货量',
    packaging: '包装明细',
    accessory: '附件',
    operation: '操作',
    addaccessory: '添加附件',
    accessoryCount: '个附件',
    shippingList: '发货清单',
    setASN: '创建ASN',
    purchaseNo: '订单号',
    purchaseBatchSeq: '分批序',
    expectedArrivalDate: '交货日期',
    purchaseUnitNo: '采购中心',
    orderType: '订单性质',
    deliverStatus: '状态',
    optionDate: '请选择日期',
    label: [{ value: 1, label: '一般订单' }, { value: 2, label: '委外订单' }, { value: 3, label: 'VMI订单' }],
    hint1: '请选择预计交货日期',
    hint2: '请选择订单性质',
    hint3: '请选采购中心',
    remove: '删除',
    clearDataTip: '更改采购中心会清空所选数据',
    unDeliveryQty: '当前可发货排程量',
    receiveQty: '已收货量',
    unReceiveQty: '未交量',
    onWayQty: '在途量',
    overQty: '超交量',
    unitNo: '单位',
    flushSleeve: '剩余齐料套数'
  },
  search: {
    purchaseDateRange: '订单日期范围',
    purchaseDateStart: '订单日期起',
    purchaseDateEnd: '订单日期止',
    expectArrivalDateRange: '预计交货日期范围',
    expectArrivalDateStart: '预计交货日期-起',
    expectArrivalDateEnd: '预计交货日期-止',
    purchaseNo: '订单单号',
    goodsNo: '料号',
    goodsName: '品名',
    searchPlaceholder: '品名/订单号'
  },
  deliverParticulars: {
    requiredShippingAddressId: '请选择收货地址',
    requiredDeliveryAddressId: '请选择发货地址',
    deliverParticulars: '发货单详情',
    deliveryDate: '发货日期',
    workNo: '工单单号',
    boxNum: '箱数',
    customerInformation: '客户资料',
    site: '采购中心',
    shippingAddress: '发货地址',
    consignee: '收货人',
    contactPhone: '联系方式',
    receivingTime: '收货时段',
    billInfo: '发货资料',
    orderType: '发货单性质',
    orderType1: '一般订单',
    orderType2: '委外订单',
    orderType3: 'VMI订单',
    deliveryAddress: '收货地址',
    sender: '发货人',
    delWarehouse: '发货仓库',
    predictArriveData: '预计到达日期',
    restsMessage: '其他信息',
    remarks: '备注',
    accessory: '附件',
    addaccessory: '添加附件',
    invoice: '发票',
    delete: '删除',
    added: '已添加',
    invoiceNumber: '张发票',
    look: '点击查看/继续添加',
    dispatchDetail: '发货单明细',
    goodsNo: '料号',
    goodsName: '品名',
    spec: '规格',
    superRemarks: '采购备注',
    purchaseSeq: '项次-项序',
    purchaseNo: '订单号',
    purchaseBatchSeq: '分批序',
    deliveryQty: '发货量',
    giftQty: '赠送量',
    valuationQty: '计价数量',
    supRemarks: '供应商备注',
    operation: '操作',
    numAccessory: '个附件',
    information: 'ASN运单信息',
    advanced: '(提前)',
    delay: '(延迟)',
    normal: '(正常)',
    states: ['', '(正常)', '(提前)', '(延迟)'],
    batchPurQty: '订单量',
    shippingWarehouse: '收货仓库',
    deliveryQtys: '发货总量',
    receiveQtys: '收货总量',
    deliveryStatus: '送货单状态',
    deliveryStatusText: ['', '正常送货', '提前送货', '延迟送货'],
    comfirmTip: '确认发货吗？',
    comfirm: '确认',
    back: '返回',
    overQty: '超交量',
    unDeliveryQty: '未交量',
    deliveryQtyError: '发货量数量有误',
    expectArrivalDate: '期望到货日期',
    unitNo: '单位'
  }
}
